import React, { createContext, useEffect, useState } from 'react';
import userApi from '../api/userApi';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

  // --- CARICA USER ---
  let rawUser = localStorage.getItem('user');
  let storedUser = null;

  if (rawUser && rawUser !== 'undefined' && rawUser !== 'null' && rawUser !== '') {
    try {
      storedUser = JSON.parse(rawUser);
    } catch (e) {
      console.warn("User corrotto in localStorage, rimosso:", rawUser);
      localStorage.removeItem('user');
    }
  }

  const [user, setUser] = useState(storedUser);
  const [token, setToken] = useState(localStorage.getItem('token'));

  // --- SE HO TOKEN MA NON HO USER, RECUPERO USER DA BACKEND ---
  useEffect(() => {
    if (token && !user) {
      const raw = localStorage.getItem('user');
      let fallbackUser = null;

      if (raw && raw !== 'undefined' && raw !== 'null') {
        try {
          fallbackUser = JSON.parse(raw);
        } catch {}
      }

      const username = fallbackUser?.username;
      if (!username) return;

      userApi.me(username)
        .then(res => {
          setUser(res.data);
          localStorage.setItem('user', JSON.stringify(res.data));
        })
        .catch(err => {
          console.warn("Errore nel recupero user:", err);
          setUser(null);
          localStorage.removeItem('user');
        });
    }
  }, [token, user]);

  // --- LOGIN ---
  const login = ({ token, user }) => {
    console.log("AuthContext.login token:", token);
    console.log("AuthContext.login username:", token);
    console.log("AuthContext.login user:", user);
    setToken(token);
    setUser(user);

    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
  };

  // --- LOGOUT ---
  const logout = () => {
    setToken(null);
    setUser(null);
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('loginState');
  };

  return (
    <AuthContext.Provider value={{ token, user, setUser, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};